import { ContactTitleEnum } from '../../../enums/contact-title.enum';
import { PlatformContactTypeEnum } from '../../../../platform/contacts/enums/platform-contact-type.enum';

/**
 * Applies create-path defaults for platform-owned contacts.
 */
export function applyPlatformContactCreateDefaults<
  T extends {
    type?: PlatformContactTypeEnum | null;
    title?: ContactTitleEnum | null;
  },
>(contact: T): T {
  contact.type = contact.type ?? PlatformContactTypeEnum.TENANT;
  contact.title = contact.title ?? ContactTitleEnum.NONE;

  return contact;
}
